import React, { useEffect, useState } from "react";
import api from "../../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "../loader";
import moment from "moment";
import copy from "copy-to-clipboard";
import { useAlert } from "react-alert";
import { TextPopupModal } from "../../modals/textPopup";

function CheckGodzillaAccess({ match }) {
  const alert = useAlert();

  const [data, setData] = useState({});
  const [noOfUser, setnoOfUser] = useState(0);
  const [UID, setUID] = useState("");
  const [resetPage, setResetPage] = useState(false);
  const [loader, setLoader] = useState(false);

  const [popupText, setPopupText] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleSearchWeex = async () => {
    try {
      if (UID) {
        setLoader(true);
        let payload = { UID: UID };
        const res = await api.checkWeexByAdmin(payload);
        console.log(res);

        if (res?.success) {
          // alert.show(res?.message);
          setPopupText(res?.message);
          handleShow();
          if (res?.alreadyUser?.email) {
            setData(res?.alreadyUser);
          } else {
            setData({});
          }
        } else {
          setPopupText(res?.message);
          handleShow();
          // alert.show(res?.message);
        }
        setLoader(false);
      } else {
        alert.show("Please insert UID for search");
        setLoader(false);
      }
    } catch (error) {
      setPopupText(error?.message);
      handleShow();
      // alert.show(error?.message || "Something Went Wrong.");
      setLoader(false);
    }
  };
  const handleSearchMexc = async () => {
    try {
      if (UID) {
        setLoader(true);

        let payload = { UID: UID };
        const res = await api.checkMexcByAdmin(payload);
        console.log(res);

        if (res?.success) {
          setPopupText(res?.message);
          handleShow();
          if (res?.alreadyUser?.email) {
            setData(res?.alreadyUser);
          } else {
            setData({});
          }
        } else {
          setPopupText(res?.message);
          handleShow();
          alert.show(res?.message);
        }
        setLoader(false);
      } else {
        alert.show("Please insert UID for search");
        setLoader(false);
      }
    } catch (error) {
      setPopupText(error?.message);
      handleShow();
      // alert.show(error?.message || "Something Went Wrong.");
      setLoader(false);
    }
  };
  const handleReset = () => {
    setData({});
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <div className="wallet-users-management-wrapper">
              {/* Header Section */}
              <div className="wallet-users-header-section mb-5">
                <div className="wallet-users-header-content">
                  <div className="wallet-users-title-section">
                    <h1 className="wallet-users-main-title">
                      <i className="fas fa-chart-line crypto-trades-icon me-3"></i>
                      Check Godzilla Access
                    </h1>
                    <p className="wallet-users-subtitle">
                      Check godzilla access directly by exchange.
                    </p>
                  </div>

                  {/* Search and Reset Section */}
                  <div className="wallet-users-search-section">
                    <div className="wallet-users-search-container">
                      <div className="wallet-users-search-input-wrapper">
                        <i className="fas fa-search wallet-users-search-icon"></i>
                        <input
                          type="text"
                          className="wallet-users-search-input"
                          placeholder="Enter UID..."
                          value={UID}
                          onChange={(e) => setUID(e.target.value)}
                          onKeyPress={(e) =>
                            e.key === "Enter" && handleSearchWeex()
                          }
                        />
                        {UID && (
                          <button
                            className="wallet-users-search-clear"
                            onClick={() => handleSearchWeex()}
                          >
                            <i className="fas fa-times"></i>
                          </button>
                        )}
                      </div>
                      <button
                        className="wallet-users-search-btn"
                        onClick={handleSearchWeex}
                      >
                        <i className="fas fa-magnifying-glass me-2"></i>
                        Search Weex
                      </button>
                    </div>
                    <button
                      className="wallet-users-reset-btn"
                      onClick={handleSearchMexc}
                    >
                      <i className="fas fa-magnifying-glass me-2"></i>
                      Search Mexc
                    </button>
                  </div>
                </div>
              </div>

              {/* Table Section */}
              <Table data={data} />
            </div>
          </div>
        </div>
      </div>
      <TextPopupModal show={show} handleClose={handleClose} text={popupText} />

      {loader && <Loader />}

      {/* Styles */}
      <style jsx>{``}</style>
    </>
  );
}

const Table = ({ data }) => {
  const [copyText, setCopyText] = useState("");

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  const handleCopy = (text) => {
    copy(text);
    setCopyText(text);
    setTimeout(() => {
      setCopyText("");
    }, 3000);
  };

  return (
    <>
      <div className="card sortby-box br-10 border-transparent mt-3">
        <div className="card-header br-10  bg-white border-transparent py-3 ">
          <div className="table-responsive">
            <table className="table table-hover drivers-table">
              <thead>
                <tr>
                  <th scope="col" className="">
                    Joined At
                  </th>
                  <th scope="col" className="">
                    Name
                  </th>
                  <th scope="col" className="">
                    Email
                  </th>
                  <th scope="col" className="">
                    Phone
                  </th>
                  <th scope="col" className="">
                    Wallet
                  </th>
                  <th scope="col" className="">
                    country
                  </th>
                  <th scope="col" className="">
                    DOB
                  </th>
                  <th scope="col" className="">
                    Gender
                  </th>
                  <th scope="col" className="">
                    <div className="w-max-c">Email verified</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {data?.email && (
                  <tr>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {formatDate(data?.createdAt)}
                      </div>
                    </td>
                    <td scope="row">
                      <div className="table-text-dark w-max-c db">
                        {data?.name}
                      </div>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {data?.email}
                      </span>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {data?.phone ? data?.phone : "-"}
                      </span>
                    </td>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {data?.wallet ? (
                          <>
                            <span className="wallet-address">
                              {data?.wallet}
                            </span>
                            <span
                              className="copyToClip"
                              title="Copy wallet address"
                            >
                              <i
                                onClick={() => handleCopy(data?.wallet)}
                                className="fa-regular fa-copy cursor-pointer me-1"
                              ></i>
                              {copyText === "Copied!" ? "Copied!" : "Copy"}
                            </span>
                          </>
                        ) : (
                          "-"
                        )}
                      </div>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {data?.country ? data?.country : "-"}
                      </span>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {data?.dob}
                      </span>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {data?.gender}
                      </span>
                    </td>
                    <td>
                      {data?.emailVerified ? (
                        <span className="badge bg-success w-max-c db">
                          verified
                        </span>
                      ) : (
                        <span className="badge bg-danger w-max-c db">
                          not verified
                        </span>
                      )}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default CheckGodzillaAccess;
